import JsBarcode from "jsbarcode";
import React from "react";
import { Col, Row, Label, ModalBody } from "reactstrap";

export default class PrintLabelComponent extends React.PureComponent {
  componentDidMount() {
    JsBarcode(".barcode").init();
  }

  render() {
    return (
      <Col>
        <Row
          style={{
            justifyContent: "space-between",
            paddingRight: "1rem",
            paddingLeft: "1rem",
          }}
        >
          <Col style={{ alignItems: "center", display: "flex" }}>
            <Label className="display-3">E-Istiqlal</Label>
          </Col>
          <Col
            style={{
              justifyContent: "flex-end",
              alignItems: "center",
              display: "flex",
            }}
          >
            <p className="float-right mb-0 pb-0">
              Non Tunai
              <br />
              <p className="text-danger float-right mt-0 pt-0">
                <small>Penjual tidak perlu bayar apapun ke kurir</small>
              </p>
            </p>
          </Col>
        </Row>
        <ModalBody>
          <Row className="row-eq-height">
            <Col xs={6}>
              <div style={{ backgroundColor: "#c7c5c5" }}>
                <p className="display-3  pb-0">NCS</p>
                <p className="ml-1 mb-1 h4">
                  {typeof this.props.order.items[0].shipping === "object"
                    ? this.props.order.items[0].shipping.Service
                    : "-"}
                </p>
              </div>
            </Col>
            <Col xs={6}>
              <div
                className="mb-0 p-0"
                style={{ height: "150px", width: "100%" }}
              >
                <svg
                  class="barcode"
                  jsbarcode-format="CODE39"
                  jsbarcode-value={this.props.order.items[0].refno || ""}
                  jsbarcode-width={1}
                  jsbarcode-height={125}
                ></svg>
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col xs={6}>
              <p className="font-weight-bold m-0">Name:</p>
            </Col>
            <Col xs={6}>
              <Label>{this.props.order.address[0].fullName}</Label>
            </Col>
            <Col xs={6}>
              <p className="font-weight-bold m-0">Phone Number:</p>
            </Col>
            <Col xs={6}>
              <Label>{this.props.order.address[0].phone}</Label>
            </Col>
            <Col xs={6}>
              <p className="font-weight-bold m-0">Email:</p>
            </Col>
            <Col xs={6}>
              <Label>{this.props.order.address[0].email}</Label>
            </Col>
            <Col xs={6}>
              <p className="font-weight-bold m-0">Shipping Address:</p>
            </Col>
            <Col xs={6}>
              {this.props.order.address.length > 0 ? (
                <div>
                  <p className="m-0 p-0">
                    {this.props.order.address[0].address1 || ""}
                  </p>
                  <p className="m-0 p-0">
                    {this.props.order.address[0].address2 || ""}
                  </p>
                  <p className="m-0 p-0">
                    {this.props.order.address[0].postal || ""}
                  </p>
                </div>
              ) : (
                "-"
              )}
            </Col>
          </Row>
        </ModalBody>
      </Col>
    );
  }
}
